import { PRODUCT_SWATCH_SET_SKU, TOGGLE_ALL_SHADES } from './actions';

const setProductSKU = (state, action) => ({
  ...state,
  selectedSKU: action.selectedSKU,
});

const toggleAllShades = state => ({
  ...state,
  isOpen: !state.isOpen,
});

const reducer = {
  [PRODUCT_SWATCH_SET_SKU]: setProductSKU,
  [TOGGLE_ALL_SHADES]: toggleAllShades,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
